import { Injectable } from '@angular/core';
import { BaseProvider } from '../../../../shared/providers/base-provider';
import { OverviewMapNotifier } from './overview-map-notifier';
import { OverviewMapState } from './overview-map-state';

@Injectable()
export class OverviewMapProvider extends BaseProvider<OverviewMapNotifier, OverviewMapState> {
  constructor() {
    super(OverviewMapNotifier);
  }
}
